import React, { useEffect, useState } from "react"
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from "react-router"
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import RightbarDI from 'pages/main/documentsIn/Rightbar'
import RightbarDR from 'pages/main/documentsReturn/Rightbar'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'

import { httpOk, GET, POST, PUT, FILE_D } from 'helpers/api'
import { formatDate, formatMoney, returnSign, findKeyFromArrayByValue, PAGE_SIZES } from 'helpers/helpers'
import { businessToday } from 'helpers/businessDay'

function Index() {
	const { t } = useTranslation()
	const { supplier_id } = useParams()
	const [searchParams] = useSearchParams()

	const reduxAccount = useSelector(state => state.account)

	// Переход из уведомления (оплата принята / отклонена контрагентом): ?pos_id=..&highlight=..
	// Точка — из ссылки, период расширяем на 3 месяца назад, чтобы операция точно попала в выборку.
	const queryPosId = searchParams.get('pos_id')
	const highlightMode = !!searchParams.get('highlight')

	const paymentTypes = [{ 'id': 1, 'name': t('cash') }, { 'id': 3, 'name': t('money_transfer') }]
	const amountTypes = [{ 'id': 1, 'name': t('amortization') }, { 'id': 2, 'name': t('debt') }]

	const transactionType = [
		{ 'id': 'plus', 'name': t('debit') },
		{ 'id': 'minus', 'name': t('credit') },
	]

	const date = new Date()

	const [data, setData] = useState({})
	const [poses, setPoses] = useState([])
	const [modalPayment, setModalPayment] = useState(false)
	const [modalChangePayment, setModalChangePayment] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [showRightBar, setShowRightBar] = useState({
		'cheques': false,
		'documents_in': false,
		'documents_return': false,
	})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		start_date: formatDate(
			new Date(date.getFullYear(), date.getMonth() - (highlightMode ? 3 : 0), 1),
			'yyyy-MM-dd'
		),
		end_date: businessToday(),
		pos_id: queryPosId ? Number(queryPosId) : reduxAccount.pos_id,
		transaction_type: null,
		search: '',
		size: 20,
	})
	const [pagination, setPagination] = useState({
		url: `/report-suppliers-history/${supplier_id}`,
		size: 20,
		response: null
	})

	async function searchWithFilter(passedData = {}) {
		var filterUrl = `/report-suppliers-history/${supplier_id}`
		var urlParams = ""
		const filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		checkFilter(filterDataCopy)

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.transaction_type)
			urlParams += returnSign(urlParams) + 'transaction_type=' + filterDataCopy.transaction_type
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/report-suppliers-history/${supplier_id}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'size': filterDataCopy.size, 'response': response.data })
		}

		setFilterData(filterDataCopy)
		setDropdownIsOpen(false)
	}

	async function downloadExcelFile() {
		var filterUrl = `/report-suppliers-history/${supplier_id}`
		var urlParams = ""

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.transaction_type)
			urlParams += returnSign(urlParams) + 'transaction_type=' + filterData.transaction_type
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		urlParams += returnSign(urlParams) + 'excel=true'

		const responseExcel = await FILE_D(filterUrl + urlParams, { loader: true })
		if (httpOk(responseExcel)) {
			const file = new Blob([responseExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const fileUrl = URL.createObjectURL(file)
			const link = document.createElement('a')
			link.href = fileUrl
			link.setAttribute('download', `supplier-debts.xlsx`)
			document.body.appendChild(link)
			link.click()
			URL.revokeObjectURL(fileUrl)
		}
	}

	async function payment(e) {
		e.preventDefault();

		var selectedItemCopy = { ...selectedItem }

		if (selectedItemCopy.amount_type_id === 2) {
			selectedItemCopy.amount_out = selectedItemCopy.amount_in
			selectedItemCopy.amount_in = 0
		}

		var sendData = {}
		sendData.amount_in = selectedItemCopy.amount_in
		sendData.amount_out = selectedItemCopy.amount_out
		sendData.supplier_id = selectedItemCopy.supplier_id
		sendData.payment_type_id = selectedItemCopy.payment_type_id
		sendData.pos_id = selectedItemCopy.pos_id
		sendData.note = selectedItemCopy.note

		var response = await POST('/suppliers-payment', sendData, { loader: true })

		if (httpOk(response)) {
			showPaymentModal(false)
			searchWithFilter()
		}
	}

	async function changePayment(e) {
		e.preventDefault();

		var response = await PUT('/suppliers-payment', selectedItem, { loader: true })

		if (httpOk(response)) {
			toggleModalChangePayment(false)
			searchWithFilter()
		}
	}

	function showPaymentModal(bool) {
		var selectedItemCopy = { ...data.supplier }
		if (!bool) {
			selectedItemCopy.payment_type_id = 1
			selectedItemCopy.amount_type_id = 1
			selectedItemCopy.amount_in = ''
			selectedItemCopy.amount_out = 0
		} else {
			selectedItemCopy.payment_type_id = 1
			selectedItemCopy.amount_type_id = 1
			selectedItemCopy.amount_in = ''
			selectedItemCopy.amount_out = 0
			setSelectedItem(selectedItemCopy)
		}

		setModalPayment(bool)
	}

	function toggleModalChangePayment(bool, item = {}) {
		if (bool) {
			var itemCopy = { ...item }
			itemCopy.changed_amount_in = itemCopy.amount_in

			setSelectedItem(itemCopy)
			setModalChangePayment(true)
		} else {
			setModalChangePayment(false)
		}
	}

	// Документы, которые умеем открывать из истории расчётов.
	// Добавить новый тип — дописать сюда строку и отрисовать его боковую панель ниже.
	const documentEndpoints = {
		'documents_in': '/documents-in',
		'documents_return': '/documents-return',
	}

	// Строка ведёт на документ, только если он у неё есть и мы умеем его открыть —
	// платежи и старые записи без entity_id остаются некликабельными.
	function isDocumentRow(item) {
		return !!item.entity_id && !!documentEndpoints[item.entity_type]
	}

	function handleSelectTemplate(item) {
		if (!isDocumentRow(item)) return

		toggleRightbar(true, item)
	}

	async function toggleRightbar(boolean = false, item = {}) {
		if (!boolean) {
			setSelectedItem({})
			setShowRightBar({ 'documents_in': false, 'documents_return': false })
			return
		}

		const response = await GET(`${documentEndpoints[item.entity_type]}/${item.entity_id}`, {}, { loader: true })
		if (httpOk(response)) {
			setSelectedItem(response.data)
			setShowRightBar({
				'documents_in': item.entity_type === 'documents_in',
				'documents_return': item.entity_type === 'documents_return',
			})
		}
	}

	function resetFilter() {
		setFilterData({
			pos_id: null,
			transaction_type: null,
			search: '',
		})
		searchWithFilter()
	}

	function checkFilter(currentFilterData = filterData) {
		if (
			currentFilterData.pos_id === null &&
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page) {
		const nextFilterData = { ...filterData, 'page': page }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	function handlePageSizeChange(size) {
		const nextFilterData = { ...filterData, size, page: null }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	useEffect(() => {
		getPoses()
			searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex text-truncate">
				<h4 className="vertical-center h-100">
					{t('supplier')}
				</h4>
				<div className="vertical-center">
					<i className="uil uil-angle-double-right fz-20"></i>
				</div>
				<div className="vertical-center" title={data?.supplier?.supplier_id}>
					<h6>{data?.supplier?.name}</h6>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}
								onSearchChange={(search) => {
									const nextFilterData = { ...filterData, search, page: null }
									setFilterData(nextFilterData)
									searchWithFilter({ filterData: nextFilterData })
								}}>
							</FilterSearch>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="d-flex gap-2">
											<div className="form-group w-100">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group w-100">
												<label>{t('transaction_type')}</label>
												<Select
													isClearable
													options={transactionType}
													value={transactionType.find(option => option.id === filterData.transaction_type) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'transaction_type': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="d-flex gap-2">
											<div className="form-group w-100">
												<label>{t('period')}</label>
												<PeriodPicker
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													onChange={(period) => setFilterData({ ...filterData, ...period })}
													withTime={false}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter({ filterData: { ...filterData } })}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button type="button" className="btn btn-outline-primary btn-wide-2"
									onClick={() => downloadExcelFile()}
									title="EXCEL">
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>

							<div className="d-none">
								<button className="btn btn-outline-primary btn-wide"
									onClick={() => showPaymentModal(true)}>
									{t('pay')}
								</button>
							</div>
						</div>
						<div className="d-flex gap-2">
							<div className="vertical-center">
								<h4><b>{t('amount')}</b>:</h4>
							</div>
							<div className="vertical-center">
								<h5 className="text-end">
									<span className={`${data.total_amount > 0 ? 'text-success' : 'text-danger'}`}>
										{formatMoney(data.total_amount)}
									</span>
								</h5>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.transaction_type &&
									<span className="me-2">
										<b>{t('transaction_type')}: </b>
										{findKeyFromArrayByValue(transactionType, 'id', filterData.transaction_type, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('pos')}</th>
									<th style={{ 'width': '10%' }}>{t('payment')}</th>
									<th style={{ 'width': '30%' }}>{t('note')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('debit')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('credit')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('total')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className={isDocumentRow(item) ? 'cursor' : ''}
										onClick={() => handleSelectTemplate(item)}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">{item.pos_name}</td>
										<td className="td-ellipsis">{item.account_chef_name}</td>
										<td className="td-ellipsis" title={item.note}>{item.note}</td>
										<td className="text-center text-nowrap">
											{item.status === 1 &&
												<span>{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</span>
											}
											{item.status === -1 &&
												<span className="text-danger">{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</span>
											}
											{item.status === -2 &&
												<span className="text-nowrap">
													{formatDate(item.created_at, 'dd.MM.yy HH:mm')}
													<span className="badge bg-warning text-dark ms-1">{t('expected')}</span>
												</span>
											}
										</td>
										<td className="text-end text-nowrap">
											{item.transaction_type === 'plus' && <span className="text-success">{formatMoney(item.amount)}</span>}
										</td>
										<td className="text-end text-nowrap">
											{item.transaction_type === 'minus' && <span>{formatMoney(item.amount)}</span>}
										</td>
										<td className={`text-end text-nowrap ${item.balance >= 0 ? 'text-success' : 'text-danger'}`}>
											{formatMoney(item.balance)}
										</td>
									</tr>
								))}
							</tbody>
							<tfoot>
								<tr>
									<td colSpan="7" className="text-end fw-bold">{t('total')}</td>
									<td className={`text-end text-nowrap fw-bold ${data.total_amount >= 0 ? 'text-success' : 'text-danger'}`}>
										{formatMoney(data.total_amount)}
									</td>
								</tr>
							</tfoot>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}
							showPageSizeSelect
							pageSizeOptions={PAGE_SIZES}
							onPageSizeChange={handlePageSizeChange}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL PAYMENT */}
			<Modal show={modalPayment} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => showPaymentModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('pay')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<span>{t('pos')}</span>
						<span>{selectedItem.pos_name}</span>
					</div>
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<span>{t('supplier')}</span>
						<span>{selectedItem.name}</span>
					</div>
					<form onSubmit={payment} autoComplete="off">
						<div className="form-group">
							<label>{t('payment_method')}</label>
							<Select
								options={paymentTypes}
								value={paymentTypes.find(option => option.id === selectedItem.payment_type_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'payment_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('choose_payment_type')}</label>
							<Select
								options={amountTypes}
								value={amountTypes.find(option => option.id === selectedItem.amount_type_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'amount_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('amount')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="amount_in" autoFocus
								value={selectedItem.amount_in ? formatMoney(selectedItem.amount_in) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount_in': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => showPaymentModal(false)} tabIndex="-1">{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100" disabled={!selectedItem.amount_in && !selectedItem.amount_out}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT */}

			{/* MODAL CHANGE PAYMENT */}
			<Modal show={modalChangePayment} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalChangePayment(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('pay')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={changePayment} autoComplete="off">
						<div className="form-group">
							<label>{t('amortization')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="amount_in" autoFocus
								value={selectedItem.amount_in ? formatMoney(selectedItem.amount_in) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount_in': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => toggleModalChangePayment(false)} tabIndex="-1">{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!selectedItem.amount_in || !(Number(selectedItem.amount_in) < Number(selectedItem.changed_amount_in))}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CHANGE PAYMENT */}

			{showRightBar.documents_in &&
				<RightbarDI
					showRightBar={showRightBar.documents_in}
					setShowRightBar={setShowRightBar}
					data={selectedItem}>
				</RightbarDI>
			}

			{showRightBar.documents_return &&
				<RightbarDR
					showRightBar={showRightBar.documents_return}
					setShowRightBar={setShowRightBar}
					data={selectedItem}>
				</RightbarDR>
			}
		</>
	)
}

export default Index
